import React from "react";
import Header from "../Header/Header";
import "../Testimonials/Testimonials.css";
import ReactPlayer from "react-player";
import Slider from "react-slick";
import Footer from "../Footer/Footer";
import { Helmet } from 'react-helmet-async';

export default function Testimonials() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
         <Helmet>
      <title>The Hearing Centre | Hearing Aids Testimonials</title>
      <meta name="description" content="Wondering what our clients have to say about their hearing transformations? Listen to their stories firsthand! Explore our Testimonials page today." />
      <meta property="og:title" content="The Hearing Centre | Hearing Aids Testimonials"></meta>
      <meta property="og:description" content="Wondering what our clients have to say about their hearing transformations? Listen to their stories firsthand! Explore our Testimonials page today."></meta>
    </Helmet>
      <Header />
      <section className="hearing_service Testimonials">
        <div className="container">
          <h1 className="Heading_text">Testimonials</h1>
        </div>
      </section>
      <section className="Testimonials_heading">
        <div className="container">
          <h1 class="Heading_text">Our Video Testimonials</h1>
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <ReactPlayer
                  width="100%"
                  height="250px"
                  url="https://www.youtube.com/watch?embeds_referring_euri=https%3A%2F%2Fwww.thehearingcentre.sg%2F&embeds_referring_origin=https%3A%2F%2Fwww.thehearingcentre.sg&source_ve_path=Mjg2NjAsMTY0OTksMjg2NjQsMTY0NTAz&feature=emb_share&v=q7Lf236UiJc"
                  className="Testimonial_video"
                />
                <div class="card-body">
                  {" "}
                  <h5 class="card-title">From Ms Margaret Ong; </h5>
                  <p class="card-text">
                    I’m very glad to have found The Hearing Centre, until today
                    they are still giving me top-notch service.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <ReactPlayer
                  width="100%"
                  height="250px"
                  url="https://www.youtube.com/watch?embeds_referring_euri=https%3A%2F%2Fwww.thehearingcentre.sg%2F&embeds_referring_origin=https%3A%2F%2Fwww.thehearingcentre.sg&source_ve_path=MTY0OTksMjg2NjQsMTY0NTAz&feature=emb_share&v=LxhBU6L_Rpk"
                  className="Testimonial_video"
                />
                <div class="card-body">
                  {" "}
                  <h5 class="card-title">From Father of Yang J.X; </h5>
                  <p class="card-text">
                    I went to The Hearing Centre and met up with Ms Brenda Fu,
                    who recommended this pair of Phonak hearing aids. After
                    wearing the hearing aid, my son has had great improvement …
                    when we talk to him now, his response and attention has
                    improved a lot. Thank you!
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <ReactPlayer
                  width="100%"
                  height="250px"
                  url="https://www.youtube.com/embed/DkZWgcxjWug?feature=oembed&enablejsapi=1&origin=https%3A%2F%2Fwww.thehearingcentre.sg"
                  className="Testimonial_video"
                />

                <div class="card-body">
                  {" "}
                  <h5 class="card-title">From Mdm Thong M.K: </h5>
                  <p class="card-text">
                    I really thank Ms Fu from The Hearing Centre for helping me
                    to hear again.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <ReactPlayer
                  width="100%"
                  height="250px"
                  url="https://www.youtube.com/watch?si=xsRr-Wq-PlfkB1ph&embeds_referring_euri=https%3A%2F%2Fwww.thehearingcentre.sg%2F&embeds_referring_origin=https%3A%2F%2Fwww.thehearingcentre.sg&source_ve_path=MTY0OTksMjg2NjQsMTY0NTA2&feature=emb_share&v=IDZIbI_mGq4"
                  className="Testimonial_video"
                />
                <div class="card-body">
                  {" "}
                  <h5 class="card-title">From Ms Meena; </h5>
                  <p class="card-text">
                    After using hearing aid, life became more easy: I was able
                    to hear when somebody talked softly.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="card">
                <ReactPlayer
                  width="100%"
                  height="250px"
                  url="https://www.youtube.com/watch?embeds_referring_euri=https%3A%2F%2Fwww.thehearingcentre.sg%2F&embeds_referring_origin=https%3A%2F%2Fwww.thehearingcentre.sg&source_ve_path=MTY0OTksMjg2NjQsMTY0NTAz&feature=emb_share&v=XAuGBbarEK8"
                  className="Testimonial_video"
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <ReactPlayer
                  width="100%"
                  height="250px"
                  url="https://www.youtube.com/watch?embeds_referring_euri=https%3A%2F%2Fwww.thehearingcentre.sg%2F&embeds_referring_origin=https%3A%2F%2Fwww.thehearingcentre.sg&source_ve_path=MTY0OTksMjg2NjQsMTY0NTAz&feature=emb_share&v=00s4UJXX3fA"
                  className="Testimonial_video"
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <ReactPlayer
                  width="100%"
                  height="250px"
                  url="https://www.youtube.com/watch?embeds_referring_euri=https%3A%2F%2Fwww.thehearingcentre.sg%2F&embeds_referring_origin=https%3A%2F%2Fwww.thehearingcentre.sg&source_ve_path=MTY0OTksMjg2NjQsMTY0NTAz&feature=emb_share&v=vNQuT48W3ys"
                  className="Testimonial_video"
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <ReactPlayer
                  width="100%"
                  height="250px"
                  url="https://www.youtube.com/watch?embeds_referring_euri=https%3A%2F%2Fwww.thehearingcentre.sg%2F&embeds_referring_origin=https%3A%2F%2Fwww.thehearingcentre.sg&source_ve_path=MTY0OTksMjg2NjQsMTY0NTAz&feature=emb_share&v=EYZdMH25hbI"
                  className="Testimonial_video"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="Testimonials_Video">
        <div className="container">
          <h1 class="Heading_text">Our Testimonials & Google Reviews</h1>

          <div className="silder_Testimonials ">
            <Slider {...settings}>
              <div className="box_side">
                <h1>
                  OUR EXPERIENCE WITH THE HEARING CENTRE CLEARLY STANDS OUT FROM
                  THE OTHER AUDIOLOGISTS WE CALLED OR MET IN SINGAPORE. OUR
                  DAUGHTER IS VERY ACTIVE, TO SAY THE LEAST. SAYING SHE TALKS
                  CONSTANTLY, SHOUTS OR SING EVEN, AND JUMPS ALL AROUND WOULD BE
                  A CLOSER DESCRIPTION. VERY CALMLY, PATIENTLY, AND
                  COMPASSIONATELY, ERNEST, STEPHEN AND MS INDU, TOOK THE TIME TO
                  HELP TARA WITH THE TRIAL OF HER OLD DEVICE, AND THE SELECTION
                  AND TUNING OF A NEW ONE. THEY TOOK THE TIME TO DESCRIBE TO US
                  THE VARIOUS DEVICE WE COULD CONSIDER. THEY WERE VERY HELPFUL
                  AND OFFERED TO LET US TRY ONE OF THE DEVICE AS WELL. AND WHEN,
                  LIKELY DUE TO HARSH SCHOOL RECESS TREATMENT, ONE OF THE MOLDS
                  DETACHED FROM THE TUBE, THEY FIRST MADE AN EMERGENCY REPAIR,
                  THEN ORDERED ANOTHER ONE FOR US. BEYOND THE CALL OF DUTY,
                  STEPHEN VOLUNTEERED TO DISCUSS WITH US SPEECH CHALLENGES OUR
                  DAUGHTER IS HAVING, AND RECOMMENDED US A FEW SPEECH THERAPISTS
                  TO ADDRESS SPEECH THESE ISSUES. BIG THANKS TO ERNEST, STEPHEN
                  AND MS INDU FOR TREATING US LIKE FAMILY. WE WILL BACK, AGAIN
                  AND AGAIN.
                </h1>
                <p>— From Frederic and Ting;</p>
              </div>
              <div className="box_side">
                <h1>
                  IN MEMORY OF OUR DEAR CUSTOMER, THE LATE MS. TERESA HSU, AGED
                  113 YEARS AND WAS FOUNDER OF THE HOME FOR THE AGED SICK.
                  THANKS FOR YOUR UNDYING SUPPORT FOR THE LESS FORTUNATE. WE ARE
                  BLESSED TO BE ABLE TO SERVE YOU.
                </h1>
                <p>— Ms Teresa Hsu with Ernest at The Hearing Centre</p>
              </div>
              <div className="box_side">
                <h1>
                  SHORTLY AFTER RELOCATING TO SINGAPORE, MY 83-YEAR OLD MOTHER,
                  DOROTHY STROCKBINE, VISITED US FROM UNITED STATES. IT DIDN’T
                  TAKE US LONG TO REALIZE THAT, UNFORTUNATELY, HER HEARING HAD
                  DETERIORATED SUBSTANTIALLY. FOR REASONS SHE COULDN’T EXPLAIN
                  SHE WAST’T COMFORTABLE GOING TO A HEARING SPECIALIST. SEEING
                  HOW HER HEARING LOSS WAS ROBBING HER OF THE SIMPLE THINGS IN
                  LIFE, I TOOK IT UPON MYSELF TO CONTACT ERNEST POH AT THE
                  HEARING CENTRE AND SCHEDULED AN APPOINTMENT. I WILL ADMIT MY
                  MOM WASN’T VERY HAPPY WITH ME THAT MORNING, BUT HER DEMEANOR
                  INSTANTLY CHANGED THE MINUTE SHE MET ERNEST. HIS “BEDSIDE
                  OFFICE MANNER” WAS THAT OF A SAINT – HE SPOKE TO HER IN A WAY
                  SHE UNDERSTOOD, AND HER ANXIETIES WERE IMMEDIATELY ALLEVIATED.
                  MY MOM WAS TOTALLY RECEPTIVE TO HIS RECOMMENDATIONS, AND SHE
                  LEFT HIS OFFICE TRULY LOOKING FORWARD TO GETTING HER NEW
                  HEARING AIDS IN A FEW DAYS. WHEN WE RETURNED, THE HEARING AIDS
                  FIT AND OPERATED PERFECTLY WITH NO ADJUSTMENTS NECESSARY. SHE
                  LEFT THE HEARING CENTRE BEING ABLE TO HEAR THINGS SHE’D BEEN
                  MISSING FOR YEARS. AS A DAUGHTER, THIS HAS TO ONE OF MY
                  GREATEST GIFTS TO HER.
                </h1>
                <p>— From Debbie Brells;</p>
              </div>
            </Slider>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
